import * as React from "react";

export class Silk extends React.Component<{ src?: string }, {}> {
    render() {
        let silk: any = { style: {} };
        /* istanbul ignore next - actually tested, coverage doesn't understand it */
        this.props.src && (silk.style = {
            backgroundImage: `url(${this.props.src})`
        });

        return (
            <div className="rj-racing-next-races__silk" {...silk}></div>
        )
    }
}